import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {IKtVpoAdjustmentListItem} from '../interfaces/kt-trip.interface';

@Injectable({providedIn: 'root'})
export class KtVpoAdjustmentsGridService implements GridGetService<IKtVpoAdjustmentListItem> {
  private readonly baseUrl = 'tmt/sales-orders/kt-vpo-adjustments';
  private readonly http = inject(HttpClient);

  public salesOrderId: number | null = null;

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<IKtVpoAdjustmentListItem>> {
    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',
      ...(this.salesOrderId ? {salesOrderId: this.salesOrderId} : {}),
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IKtVpoAdjustmentListItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
